import React, { useEffect, useState } from 'react';
import { Box, useWindowSize, Link } from '@miro-site/core';
import styled, { useTheme, css } from 'styled-components';
import BottomLinks from './BottomLinks';
import { jsx as _jsx } from "react/jsx-runtime";
var SecondaryNavigationWrapper = styled(Box).attrs(function (_ref) {
  var $offsetHeight = _ref.$offsetHeight,
      _ref$$isFixed = _ref.$isFixed,
      $isFixed = _ref$$isFixed === void 0 ? true : _ref$$isFixed,
      secondaryNavigation = _ref.theme.header.secondaryNavigation;
  return {
    $styles: {
      opacity: $offsetHeight > 0 ? 1 : 0,
      transform: "translateY(".concat($offsetHeight, "px)"),
      width: '100%',
      height: '200vh',
      left: 0,
      bottom: '100%',
      boxShadow: secondaryNavigation.boxShadow,
      background: secondaryNavigation.background,
      transition: secondaryNavigation.animation.container,
      position: $isFixed ? 'fixed' : 'absolute',
      willChange: 'transform',
      zIndex: 5
    }
  };
}).withConfig({
  displayName: "SecondaryNavigationContainer__SecondaryNavigationWrapper",
  componentId: "sc-pv93z6-0"
})([""]);
var BottomLinksContainer = styled(BottomLinks).withConfig({
  displayName: "SecondaryNavigationContainer__BottomLinksContainer",
  componentId: "sc-pv93z6-1"
})(["", ""], function (_ref2) {
  var $offsetHeight = _ref2.$offsetHeight;
  return $offsetHeight === 0 && css(["", "{display:none;}"], Link);
});

var SecondaryNavigationContainer = function SecondaryNavigationContainer(props) {
  var activeNavigation = props.activeNavigation,
      activeNavigationRef = props.activeNavigationRef,
      bottomLinks = props.bottomLinks,
      isFixed = props.isFixed;

  var _useState = useState(0),
      offsetHeight = _useState[0],
      setOffsetHeight = _useState[1];

  var _useWindowSize = useWindowSize(),
      height = _useWindowSize.height;

  var theme = useTheme();
  useEffect(function () {
    var newOffsetHeight = activeNavigationRef.current ? activeNavigationRef.current.offsetHeight + theme.header.height + (bottomLinks.length > 0 ? theme.header.bottomLinks.height : 0) : 0;

    if (offsetHeight !== newOffsetHeight) {
      setOffsetHeight(newOffsetHeight);
    }
  }, [activeNavigation, height]);
  return /*#__PURE__*/_jsx(SecondaryNavigationWrapper, {
    $isFixed: isFixed,
    $offsetHeight: offsetHeight,
    children: bottomLinks.length > 0 && /*#__PURE__*/_jsx(BottomLinksContainer, {
      bottomLinks: bottomLinks,
      $offsetHeight: offsetHeight
    })
  });
};

export default SecondaryNavigationContainer;